import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TableViewComponentBase } from '../table-view/table-view-component-base';

@Component({
  selector: 'modal-content',
  templateUrl: './record-detail-modal.component.html',
  styleUrls: ['./record-detail-modal.component.scss'],
  providers: [TitleCasePipe],
})
export class RecordDetailModalComponent implements OnInit {

  @Input() title = 'Detail View';

  @Input() record: object;

  @Input() index: number;

  @Input() table: TableViewComponentBase<any>

  @Input() bFormatted = true;

  @Input() bJsonVisible = false;

  constructor(
    public bsModalRef: BsModalRef,
    public titleCasePipe: TitleCasePipe
  ) { }

  ngOnInit(): void {
    this.title = `${this.titleCasePipe.transform(this.title.replace('-?table$', '').replace(/[_\-]/g, ' '))} Record`;
    if ( !this.table?.cellRendererTmplRef ) {
      this.bFormatted = false;
    }
  }

  closeModal() {
    this.bsModalRef.hide()
  }
}